import { UseCase } from '@/domain/core/UseCase'
import { UserGeometry } from '@/domain/models/UserGeometry/UserGeometry'
import { Result } from '@/domain/protocols/Result'

import type { IUserGeometryRepository } from '@/data/UserGeometryRepository/IUserGeometryRepository'

// Loads every (non soft-deleted) user geometry. DI bindings are wired in Bead 07.
export class LoadUserGeometriesUseCase implements UseCase<void, Promise<Result<UserGeometry[]>>> {
  constructor(private readonly repository: IUserGeometryRepository) {}

  async execute(): Promise<Result<UserGeometry[]>> {
    try {
      return await this.repository.getGeometries()
    } catch (error) {
      return Result.fail(error)
    }
  }
}
